import axios from 'axios'
import { UrlApi, authMail, authPass } from '../Keys'
import { toast } from "react-toastify"

const dataInicial = {
    formacion: [],
    loadingFormacion: false,
    modificacion: 'EXITO',
    loadingActualizacion: false
}

const LOADING_FORMACION = 'LOADING_FORMACION'
const FORMACION = 'FORMACION'
const FORMACION_ERROR = 'FORMACION_ERROR'

const ACTUALIZACION_EXITO = 'ACTUALIZACION_EXITO'
const ACTUALIZACION_ERROR = 'ACTUALIZACION_ERROR'

//Reducers
export default function formacionReducer(state = dataInicial, action) {
    switch (action.type) {
        case FORMACION:
            return { ...state, formacion: action.payload, loadingFormacion: action.loadingFormacion }
        case LOADING_FORMACION:
            return { ...state, loadingFormacion: action.loadingFormacion }
        case ACTUALIZACION_EXITO:
            return { ...state, modificacion: action.modificacion }
        default:
            return { ...state }
    }
}

export const formaciones = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_FORMACION,
        loadingFormacion: true
    })

    try {
        var entidad = "new_universidadporcontactos"
        var fetch =
            "<entity name='new_universidadporcontacto'>" +
            "<attribute name='new_universidad'/>" +
            "<attribute name='new_titulo'/>" +
            "<attribute name='new_fechaegreso'/>" +
            "<attribute name='new_name'/>" +
            "<attribute name='new_validado'/>" +
            "<attribute name='new_universidadporcontactoid'/>" +
            "<order descending='true' attribute='new_fechaegreso'/>" +
            "<filter type='and'>" +
            "<condition attribute='new_tipodecarrera' operator='in'>" +
            "<value>100000001</value>" +
            "<value>100000002</value>" +
            "<value>100000003</value>" +
            "<value>100000004</value>" +
            "<value>100000000</value>" +
            "<value>100000005</value>" +
            "</condition>" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='aa'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortal + "'/>" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: FORMACION,
            payload: response.data,
            loadingFormacion: false
        })
    }
    catch (error) {
        dispatch({
            type: FORMACION_ERROR,
            loadingFormacion: false
        })
    }
}

export const actualizarOtraInfo = (token, infoAdicional, id) => async (dispatch) => {

    try {

        const update = () => new Promise(async (resolve, reject) => {
            await axios.put(`${UrlApi}api/hrfactors/areaacademica`,
                {
                    "new_empleadoid": id,
                    "new_informacionadicional": infoAdicional,
                    // "new_subdisciplina": "",
                    // "new_cantidadtotaldetesis": 0,
                    // "new_canttesisdoctoralesdirigactualmente": 0,
                    // "new_canttesismaestriasdirigyconcult": 0,
                    // "new_cantmaestriasquedirigeactualmente": 0,
                    // "new_canttesinasytrabfinales": 0,
                    // "new_canttesinasytrabajosquedirigeactualmente": 0,
                    // "new_experienciaeneducacinadistancia": "",
                    // "new_conicet": null,
                    // "new_programade": null
                },
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
            ).then((response) => {
                dispatch({
                    type: ACTUALIZACION_EXITO,
                    modificacion: 'EXITO',
                    loadingActualizacion: false
                })
                resolve(response.data)
            })
                .catch(err => {
                    reject(err)
                    console.log(err)
                })
        })

        const response = await toast.promise(
            update,
            {
                pending: 'Procesando...',
                success: 'Modificación con éxito!',
                error: {
                    render({ data }) {
                        // console.log(data)
                        return `${data}`
                    }
                }
            },
            {
                theme: "dark",
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            }
        )
    } catch (error) {
        console.log(error)
        dispatch({
            type: ACTUALIZACION_ERROR,
            modificacion: 'ERROR',
            loadingActualizacion: false
        })
    }
}

export const actualizarSubdisciplina = (token, subdisciplina, id) => async (dispatch) => {

    try {

        const update = () => new Promise(async (resolve, reject) => {
            await axios.put(`${UrlApi}api/hrfactors/areaacademica`,
                {
                    "new_empleadoid": id,
                    "new_subdisciplina": subdisciplina,
                },
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
            ).then((response) => {
                dispatch({
                    type: ACTUALIZACION_EXITO,
                    modificacion: 'EXITO',
                    loadingActualizacion: false
                })
                resolve(response.data)
            })
                .catch(err => {
                    reject(err)
                    console.log(err)
                })
        })

        const response = await toast.promise(
            update,
            {
                pending: 'Procesando...',
                success: 'Modificación con éxito!',
                error: {
                    render({ data }) {
                        // console.log(data)
                        return `${data}`
                    }
                }
            },
            {
                theme: "dark",
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            }
        )
    } catch (error) {
        console.log(error)
        dispatch({
            type: ACTUALIZACION_ERROR,
            modificacion: 'ERROR',
            loadingActualizacion: false
        })
    }
}

export const actualizarTituloMaximo = (token, nivel, id) => async (dispatch) => {

    try {
        const update = () => new Promise(async (resolve, reject) => {
            await axios.put(`${UrlApi}api/hrfactors/areaacademica`,
                {
                    "new_empleadoid": id,
                    "new_nivel": nivel
                },
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
            ).then((response) => {
                dispatch({
                    type: ACTUALIZACION_EXITO,
                    modificacion: 'EXITO',
                    loadingActualizacion: false
                })
                resolve(response.data)
            })
                .catch(err => {
                    reject(err)
                    console.log(err)
                })
        })

        const response = await toast.promise(
            update,
            {
                pending: 'Procesando...',
                success: 'Modificación con éxito!',
                error: {
                    render({ data }) {
                        // console.log(data)
                        return `${data}`
                    }
                }
            },
            {
                theme: "dark",
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            }
        )
    } catch (error) {
        console.log(error)
        dispatch({
            type: ACTUALIZACION_ERROR,
            modificacion: 'ERROR',
            loadingActualizacion: false
        })
    }
}
